import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import CircularProgress from "@mui/material/CircularProgress";
import LzSApp from '@lz-app/App';
import useLzFApiCall from '@lz-services/Api';
import { useLzOnMount } from '@lz-services/Hooks';
import { lzFShowSuccessMessage } from '@lz-services/Utils';
import SalesInvoiceModel from "./sales-invoice.model";
import SalesInvoiceFormComponent from './SalesInvoiceFormComponent';

const SalesInvoiceEditScreen = () => {
    const routeParams = useParams();

    const [model, setModel] = useState(null);

    const lzApiCall = useLzFApiCall();
    const navigate = useNavigate();

    const load = async () => {
        const id = +(routeParams.id || 0);
        const data = await lzApiCall('sales-invoices/' + id);
        if (data) {
            setModel(new SalesInvoiceModel(data));
        }
    };

    useLzOnMount(() => {
        load();
    });

    const handleSubmit = async () => {
        const salesInvoice = new SalesInvoiceModel(model);
        const data = await lzApiCall('sales-invoices/' + salesInvoice.id, salesInvoice.getObject(), 'put');
        if (data) {
            lzFShowSuccessMessage('Record updated successfully!');
        }
    };
    const handleClose = () => navigate('/content/sales-invoices');

    return (
        <LzSApp.WrapperTemplate private screenTitle="Edit Sales Invoice">

            {model ?
                <SalesInvoiceFormComponent
                    data={model}
                    onChange={setModel}
                    onSubmit={handleSubmit}
                    onClose={handleClose}
                    onReload={load}
                />
                :
                <CircularProgress />
            }

        </LzSApp.WrapperTemplate>
    );

};

export default SalesInvoiceEditScreen;
